import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./MessageCard.css";
import * as React from "react";
import { CustomCard } from '../../Card';
import { css } from '../../Util';
import { Icon } from '../../Icon';
import { FocusZone } from '../../FocusZone';
import { Button } from '../../Button';
import * as Resources from '../../Resources.MessageBar';
export var MessageCard = function (props) {
    var buttonProps = props.buttonProps, className = props.className, _a = props.severity, severity = _a === void 0 ? "Info" /* Info */ : _a, iconProps = props.iconProps, onDismiss = props.onDismiss;
    var severityProps = MessageCardSeverityInternal[severity];
    var severityClassName = severityProps.className;
    var renderIconProps = iconProps || severityProps.defaultIconProps;
    return (React.createElement(CustomCard, { className: css(className, "bolt-messagecard") },
        React.createElement("div", { className: css("bolt-messagecard-content flex-row flex-grow", severityClassName) },
            React.createElement(Icon, tslib_1.__assign({}, renderIconProps, { className: css(renderIconProps.className, "bolt-messagecard-icon") })),
            React.createElement("div", { className: "bolt-messagecard-message flex-row flex-shrink" }, props.children),
            (onDismiss || (buttonProps && buttonProps.length > 0)) && (React.createElement(FocusZone, { direction: 1 /* Horizontal */ },
                React.createElement("div", { className: "bolt-messagecard-buttons flex-noshrink flex-row", role: "menubar" },
                    buttonProps && buttonProps.map(function (value, index) { return React.createElement(Button, tslib_1.__assign({ key: index }, value)); }),
                    onDismiss && (React.createElement(Button, { ariaLabel: Resources.DismissButtonLabel, className: "bolt-messagecard-close-button", iconProps: { iconName: "Cancel" }, key: "closeButton", onClick: onDismiss, subtle: true }))))))));
};
/**
 * Internal backing struct maps MessageCardSeverity to the necessary data
 */
var MessageCardSeverityInternal = {
    Info: {
        className: "severity-info",
        defaultIconProps: {
            iconName: "Info"
        }
    },
    Warning: {
        className: "severity-warning",
        defaultIconProps: { iconName: "Warning" }
    },
    Error: {
        className: "severity-error",
        defaultIconProps: { iconName: "ErrorBadge" }
    }
};
